import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';
import type { WellLogsManagerWidgetEntity } from '../../well-logs-manager-widget/WellLogsManagerWidget.entity';

import { WellLogsManagerWidgetWrapper } from '../../well-logs-manager-widget/WellLogsManagerWidget';

export function renderWellLogsManagerWidget(
  widget: WellLogsManagerWidgetEntity,
  options: TWidgetRendererOptions
): TRenderWidget {
  return () => <WellLogsManagerWidgetWrapper entity={widget} options={options} />;
}
